import jsPDF from "jspdf";
import "jspdf-autotable";

/**
 * Download rows as CSV (Excel-compatible).
 */
export function downloadCsv(filename, headers, rows) {
  const escape = (v) => {
    const s = String(v ?? "");
    if (s.includes(",") || s.includes('"') || s.includes("\n")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const lines = [headers.map(escape).join(",")];
  rows.forEach((row) => {
    lines.push(row.map(escape).join(","));
  });
  const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}

/**
 * Simple PDF table export using jspdf-autotable.
 */
export function downloadPdf(title, headers, rows, filename = "report.pdf") {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(14);
  doc.text(title, 14, 16);
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 22,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [26, 95, 74] },
  });
  doc.save(filename);
}

export const datePresets = {
  mtd: () => {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split("T")[0];
    const to = now.toISOString().split("T")[0];
    return { from, to };
  },
  ytd: () => {
    const now = new Date();
    const from = new Date(now.getFullYear(), 0, 1).toISOString().split("T")[0];
    const to = now.toISOString().split("T")[0];
    return { from, to };
  },
  last30: () => {
    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - 30);
    return { from: from.toISOString().split("T")[0], to: to.toISOString().split("T")[0] };
  },
};
